angular.module('impactx.controlChip').directive('copyToClipboardInBrackets', function () {
    return {
        scope: {
            copyValue: "=",
        },
        restrict: 'E',
        templateUrl: 'shared/clipboard/templates/copy-to-clipboard-in-brackets.html',
    }
});